import React from "react";

/**
 * Alert banner. Variant hues derive from status tokens (invariant across themes).
 * @param {Object} props
 * @param {"info"|"success"|"warning"|"error"} [props.variant="info"]
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.action]
 * @param {()=>void} [props.onDismiss]
 */
export function Alert({ variant = "info", title, action, onDismiss, children }) {
  return (
    <div className={`ds-alert ds-alert-${variant}`}>
      <div className="ds-alert-body">
        {title && <div className="ds-alert-title">{title}</div>}
        {children}
      </div>
      {action && <button className="ds-alert-action">{action}</button>}
      {onDismiss && (
        <button className="ds-alert-dismiss" aria-label="Dismiss" onClick={onDismiss}>×</button>
      )}
    </div>
  );
}
